module.exports = __webpack_public_path__ + "img/scheme_md.e39f843.webp";